class Ciel {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    // スライダー

    var swiper = new Swiper(".cielSwiper", {
      autoplay: {
        delay: 2000,
      },
      speed: 1500,
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides: true,
      loop: true,
      pagination: {
        el: '.swiper-pagination',  //ページネーションの要素のセレクタ
        type: 'bullets',  //ページネーションのタイプ
      },
      breakpoints: {
        960: {
          slidesPerView: 2.4,
          spaceBetween: 30,
        }
      }
    });

    var swiper = new Swiper(".ciel-blog-Swiper", {
      autoplay: {
        delay: 2000,
      },
      speed: 1500,
      slidesPerView: 1.4,
      spaceBetween: 0,
      centeredSlides: true,
      // loop: true,
      spaceBetween: 30,
      pagination: {
        el: '.swiper-pagination',  //ページネーションの要素のセレクタ
        type: 'bullets',  //ページネーションのタイプ
      },
      breakpoints: {
        960: {
          centeredSlides: false,
          slidesPerView: 4,
          spaceBetween: 30,
        }
      }
    });


    // ページ内遷移

    $(function(){
      $("a[href^='#']").click(function(){
        var target = $(this.hash);
        var adjust = 70;
        var position = $(target).offset().top  - adjust;
        $('html,body').animate({scrollTop: position}, 400);
        return false;
      });
    });



    // メニューチェックイベント

    function menuSelect(){
      const menu = document.querySelectorAll(".menu-content__genre");
      const menuList = document.querySelectorAll(".menu-content__price");
      const firstMenu = document.querySelector(".menu-active");
      let menuVal;



      menu.forEach(el => {
        el.addEventListener("click", () => {


          menu.forEach(allCheck => {
            if(allCheck.classList.contains("is-active")){
              allCheck.classList.remove("is-active")
            }
          })
          el.classList.add("is-active")

          menuVal = el.getAttribute("value");


          menuList.forEach(el => {
            if(el.classList.contains("menu-active")){
              el.classList.remove("menu-active")
            }
            el.style.display = "none";
            if(menuVal === el.getAttribute("data-menu")){
              el.style.display = "flex";
              el.style.opacity = 1;
            }
          })

          scrollTo(0, $('.menu-content__inner').offset().top);

        })
      })

    }

    menuSelect();


    //メニュー

    function humMenu(){
      const hum = document.querySelector(".nav-hum");
      const menuOpen = document.querySelector(".ciel-hum-menu");
      const menuList = document.querySelectorAll(".hum-list")
      // console.log(menuList);
      // console.log(menuOpen);

      hum.addEventListener("click", () => {
        hum.classList.toggle("is-active")
        menuOpen.classList.toggle("is-active")
      })

      menuList.forEach(el => {
        el.addEventListener("click" , () => {
          hum.classList.remove("is-active")
          menuOpen.classList.remove("is-active")

        })
      })
    }

    humMenu();




  }
}

// globals
class Product {
  constructor(el, opt) {
    this.el = el;
    if($(this.el).length){
      this.event();
    }
  }
  event(){
    // console.log("sss");
    var swiper = new Swiper(".slider1", {
      autoplay: {
        disableOnInteraction: false,
        delay: 4000,
        },
      speed: 600,
      slidesPerView: 2,
      spaceBetween: 20,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        // スライドの表示枚数：500px以上の場合
        960: {
          slidesPerView: 4,
        }
      }
    })
    const slideLength = document.querySelectorAll('.slider1 .swiper-slide').length
    if (slideLength < 4) {
      const swiperElm = document.querySelector('.p-product-lineup__list')
      swiperElm.classList.add('active')
    }

    var swiper = new Swiper(".slider2", {
      autoplay: {
        disableOnInteraction: false,
        delay: 4000,
      },
      speed: 600,
      loop: true,
      slidesPerView: 2,
      spaceBetween: 20,
      navigation: {
        nextEl: ".swiper-button-next02.swiper-button-next",
        prevEl: ".swiper-button-prev02.swiper-button-prev",
      },
      breakpoints: {
        // スライドの表示枚数：500px以上の場合
        960: {
          slidesPerView: 4,
        }
      },
    })
    const slideLength2 = document.querySelectorAll('.slider2 .swiper-slide').length
    if (slideLength2 < 4) {
      const swiperElm = document.querySelector('.p-product-lineup__list')
      swiperElm.classList.add('active')
    }

    var swiper = new Swiper(".slider3", {
      autoplay: {
        disableOnInteraction: false,
        delay: 4000,
      },
      speed: 600,
      loop: true,
      slidesPerView: 2,
      spaceBetween: 20,
      navigation: {
        nextEl: ".swiper-button-next03.swiper-button-next",
        prevEl: ".swiper-button-prev03.swiper-button-prev",
      },
      breakpoints: {
        // スライドの表示枚数：500px以上の場合
        960: {
          slidesPerView: 4,
        }
      },
    })
    const slideLength3 = document.querySelectorAll('.slider3 .swiper-slide').length
    if (slideLength3 < 4) {
      const swiperElm = document.querySelector('.p-product-lineup__list')
      swiperElm.classList.add('active')
    }
  }
}

class ProductNew {
  constructor(el, opt) {
    this.el = el;
    if($(this.el).length){
      this.event();
    }
  }
  event(){
    $(".js-tab-content").hide();
    $(".js-product-tab").removeClass("is-active");
  
    var hash = window.location.hash;
  
    if (hash) {
      var $targetContent = $(hash);
      if ($targetContent.length) {
        $targetContent.show();
        var index = $targetContent.index(".js-tab-content");
        $(".js-product-tab").eq(index).addClass("is-active");
      } else {
        $(".js-tab-content:first").show();
        $(".js-product-tab:first").addClass("is-active");
      }
    } else {
      $(".js-tab-content:first").show();
      $(".js-product-tab:first").addClass("is-active");
    }
  
    $(".js-product-tab").click(function () {
      $(".js-tab-content").hide();
      var index = $(this).index();
      $(".js-tab-content").eq(index).show();
  
      $(".js-product-tab").removeClass("is-active");
      $(this).addClass("is-active");
    });
    
  }
}

class Top {
    constructor(el, opt) {
      this.el = el;
      if($(this.el).length){
        this.event();
      }
    }
    event(){
      var swiper = new Swiper(".mySwiper", {
        autoplay: {
          delay: 4000,
        },
        speed: 1500,
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
				pagination: {
          el: '.swiper-pagination',  //ページネーションの要素のセレクタ
					type: 'bullets',  //ページネーションのタイプ
				},
        breakpoints: {
          960: {
            slidesPerView: 1.3,
            spaceBetween: 50,
          }
        }
      });

      if (window.matchMedia('(max-width: 979px)').matches) {
        var swiper = new Swiper(".works-achieve-swiper", {
          autoplay: {
            delay: 2000,
          },
          speed: 1500,
          slidesPerView: 1.1,
          spaceBetween: 20,
          loop: true,
          centeredSlides: true,
        });
      }

      $('.js-drawer').on({
        click: function() {
          $('.js-header').toggleClass('is-acitve');
          $('html').toggleClass('no-scroll');
        }
      })


      function topNews () {
        const newsList = document.querySelectorAll(".news-content > a")
        console.log(newsList);
        const arrowTop =  document.querySelector(".arrow-top")
        const arrowBottom =  document.querySelector(".arrow-bottom")
        let newsNum = 0;


        if(newsList.length !== 0 ){
          newsList[newsNum].classList.add("is-active");
          arrowTop.addEventListener("click", function() {
            if(newsList[0].classList.contains("is-active")){
              arrowTop.style.pointerEvents = "";
              return;
            }

            if(newsNum < newsList.length){
              newsList[newsNum].classList.remove("is-active");
              newsNum --;
              newsList[newsNum].classList.add("is-active");
            }

          })

          arrowBottom.addEventListener("click", function() {
            if(newsList[newsList.length - 1].classList.contains("is-active")){
              arrowBottom.style.pointerEvents = "";
              return;
            }

            if(newsNum < newsList.length){
              newsList[newsNum].classList.remove("is-active");
              newsNum ++;
              newsList[newsNum].classList.add("is-active");
            }
          })
        }

      }

      topNews();

      if( window.matchMedia("screen and (max-width:960px)").matches ) {
        var swiper = new Swiper(".rankingSwiper", {
          // autoplay: {
          //   disableOnInteraction: false,
          //   delay: 4000,
          //   },
          slidesPerView: 2,
          spaceBetween: 20,
          loop: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          breakpoints: {
            // スライドの表示枚数：500px以上の場合
            960: {
              slidesPerView: 4,
            }
          }
        });

        var swiper = new Swiper(".campaignSwiper", {
          // autoplay: {
          //   disableOnInteraction: false,
          //   delay: 4000,
          //   },
          slidesPerView: 1.1,
          spaceBetween: 20,
          centeredSlides: true,
          loop: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          breakpoints: {
            // スライドの表示枚数：500px以上の場合
            960: {
              slidesPerView: 4,
            }
          }
        });
      }
    }
  }

class Accordion {
	constructor(el,opt){
		this.el = el;
		this.event();
	}
	event(){
        if (window.matchMedia('(max-width: 979px)').matches) {
            $(function(){
                //クリックで動く

                const a = document.querySelector(".acc-event")
                const b = document.querySelector(".salon-content")

                $('.acc-event').click(function(){
                    if (window.matchMedia( "(min-width: 400px)" ).matches) {
                        return false;
                    } else {
                        $(this).toggleClass('active');
                        $(this).next('.salon-content').slideToggle();
                    }

                });
            });

        }

	}
}


var CFL = {
  UA: {
    raw: function raw() {
      return navigator.userAgent;
    },
    is: function is(_is) {
      var ua = CFL.UA.raw();
      if (_is === 'issp') {
        return CFL.UA.isSp();
      }
    },
    isSp: function isSp() {
      var ua = CFL.UA.raw();
      return ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0;
    },
    isTablet: function() {
      var ua = CFL.UA.raw();
      if(ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
      } else if (ua.indexOf('iPad') > -1
         || (ua.indexOf('Macintosh') > -1 && CFL.UA.Device.isTouch() )
         || ua.indexOf('Android') > 0) {
        return true;
      }

      return false;
    },
    isEdge: function() {
      return this.raw().indexOf('Edge') != -1;
    },
    isIE: function() {
      var ua = CFL.UA.raw();
      return this.raw().indexOf('Trident') != -1 ;
    }
  },
  Device: {
    isTouch: function() {
      return 'ontouchend' in document;
    }
  }
};

var isMobile = function () {
  return (window.matchMedia('(max-width: '+ APP.bp.mobile +'px)').matches)
}

var isPortrait = function() {
  let defaultOrientation = null;
  if('orientation' in window) {
    var o1 = (window.innerWidth < window.innerHeight);
    var o2 = (window.orientation % 180 == 0);
    defaultOrientation = (o1 && o2) || !(o1 || o2);
  }
  if('orientation' in window) {
    // defaultOrientationがtrueの場合、window.orientationが0か180の時は縦
    // defaultOrientationがfalseの場合、window.orientationが-90か90の時は横
    var o = (window.orientation % 180 == 0);
    if((o && defaultOrientation) || !(o || defaultOrientation)) {
      return true;
    } else {
      return false;
    }
  }
}
// class ClickEvent {
//     constructor(el,opt){
//       this.el = el;
//       if($("." + this.el).length > 0){
//         this.event();
//       }
//     }
//     event(){

// 			function clickEvent(){
// 				const career = document.querySelectorAll(".job-career__btn.selet-btn");
// 				const jobKind = document.querySelectorAll(".job-kind__btn");
// 				const stylist = document.querySelector(".js-stylist");


// 				career.forEach(item => {
// 					item.addEventListener("click", () => {
// 						career.forEach(allChecks => {
// 							if(allChecks.classList.contains("is-active")){
// 								allChecks.classList.remove("is-active")
// 							}
// 						});
// 						item.classList.add("is-active")
// 					})

// 				});

// 				jobKind.forEach(item => {
// 					item.addEventListener("click", () => {
// 						jobKind.forEach(allChecks => {
// 							if(allChecks.classList.contains("is-active")){
// 								allChecks.classList.remove("is-active")
// 							}
// 						});
// 						item.classList.add("is-active")
// 						if(item === career[0]  && item.classList.contains("is-active") && jobKind[0].classList.contains("is-active")){
// 							stylist.textContent = "aaa";
// 						}
// 					})
// 				});
// 			}

// 			function selectEvent(){

// 				const jobContent = document.querySelectorAll('.job-content');
// 				const careerBtn = document.querySelectorAll('.job-career__btn');
// 				const kindBtn = document.querySelectorAll('.job-kind__btn');
// 				let career;
// 				let job;


// 				$(".job-career input, .job-kind input").on("click", function() {
// 					careerBtn.forEach(function(el) {
// 					if(el.classList.contains("is-active")) {
// 						career = el.getAttribute('value');
// 						}
// 					})
// 					kindBtn.forEach(function(el) {
// 					if(el.classList.contains("is-active")) {
// 						job = el.getAttribute('value');
// 					}
// 					})
// 					jobContent.forEach(function(el) {
// 					el.style.display = "none";
// 					if(career == el.getAttribute("data-recruit") && job == el.getAttribute("data-job")) {
// 						el.style.display = "flex";
// 					}
// 					})


// 					})

// 			}
// 			clickEvent();

// 			selectEvent();
//     }

//   }


class FooterMenu {
	constructor(el,opt){
		this.el = el;
		this.event();
	}
	event(){
    $( '.js-f-menu' ).on( 'click', function() {
      $( this ).toggleClass( 'add-active' );
      $( this ).next().slideToggle();
    });
	}
}


class HairModaal {
	constructor(el,opt){
		this.el = el;
		this.event();
	}
	event(){
 //画像のモーダル
 $(".gallery").modaal({
    type: 'image',
    overlay_close:true,//モーダル背景クリック時に閉じるか
    before_open:function(){// モーダルが開く前に行う動作
      $('html').css('overflow-y','hidden');/*縦スクロールバーを出さない*/
    },
    after_close:function(){// モーダルが閉じた後に行う動作
      $('html').css('overflow-y','scroll');/*縦スクロールバーを出す*/
    }
  });
	}
}

class Hamburger {
	constructor(el,opt){
		this.el = el;
		this.event();
	}
	event(){
		if(document.querySelector(".header-hum")) {
			const humBtn = document.querySelector(".header-hum");
			const menu = document.querySelector(".menu");
			humBtn.addEventListener("click", () => {
				menu.classList.toggle("is-active");
				humBtn.classList.toggle("is-active");
			});
		}
	}
}


//noScroll
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    this.para_ele = document.querySelectorAll("." + this.el);
    this.para_ele.forEach((ele, index)=> {
      if(ele.classList.contains('js-parallax--reverse')) {
        this.translateY = '20px';
      } else {
        this.translateY = '-20px';
      }
      ele.classList.add(this.el + index);
      gsap.to('.' + this.el + index + ' img', {
        translateY: this.translateY,
        scrollTrigger: {
          trigger: '.' + this.el + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          scrub: 3,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    this.el = el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

//noScroll
class Modaal {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

  function modalClick() {

    const changeText01 = document.querySelectorAll(".modaal-interview__item01")
    const changeText02 = document.querySelectorAll(".modaal-interview__item02")
    const changeContent01 = document.querySelectorAll(".modaal-content01")
    const changeContent02 = document.querySelectorAll(".modaal-content02")
    let changeTtl01;
    let changeTtl02;

    changeText01.forEach(text => {
      text.addEventListener("click", () => {
        changeText01.forEach(allChecks => {
          if(allChecks.classList.contains("is-active")){
            allChecks.classList.remove("is-active")
          }
        });

        text.classList.add("is-active")
        changeTtl01 = text.dataset.ttl;

        changeContent01.forEach(el => {
          el.style.display = "none";
          if(el.dataset.ttl == changeTtl01){
            el.style.display = "block";
          }
        })
      })
    });


    changeText02.forEach(text => {
      text.addEventListener("click", () => {
        changeText02.forEach(allChecks => {
          if(allChecks.classList.contains("is-active")){
            allChecks.classList.remove("is-active")
          }
        });
        text.classList.add("is-active")
        changeTtl02 = text.dataset.ttl;

        changeContent02.forEach(el => {
          el.style.display = "none";
          if(el.dataset.ttl == changeTtl02){
            el.style.display = "block";
          }
        })
      })
    });

  }
  function clickEvent(){
    const career = document.querySelectorAll(".job-career__btn.selet-btn");
    const jobKind = document.querySelectorAll(".job-kind__btn");
    const stylist = document.querySelector(".js-stylist");


    career.forEach(item => {
      item.addEventListener("click", () => {
        career.forEach(allChecks => {
          if(allChecks.classList.contains("is-active")){
            allChecks.classList.remove("is-active")
          }
        });
        item.classList.add("is-active")
      })

    });

    jobKind.forEach(item => {
      item.addEventListener("click", () => {
        jobKind.forEach(allChecks => {
          if(allChecks.classList.contains("is-active")){
            allChecks.classList.remove("is-active")
          }
        });
        item.classList.add("is-active")
        if(item === career[0]  && item.classList.contains("is-active") && jobKind[0].classList.contains("is-active")){
          stylist.textContent = "aaa";
        }
      })
    });
  }

  function selectEvent(){

    const jobContent = document.querySelectorAll('.job-content');
    const careerBtn = document.querySelectorAll('.job-career__btn');
    const kindBtn = document.querySelectorAll('.job-kind__btn');
    let career;
    let job;


    $(".job-career input, .job-kind input").on("click", function() {
      careerBtn.forEach(function(el) {
      if(el.classList.contains("is-active")) {
        career = el.getAttribute('value');
        }
      })
      kindBtn.forEach(function(el) {
      if(el.classList.contains("is-active")) {
        job = el.getAttribute('value');
      }
      })
      jobContent.forEach(function(el) {
      el.style.display = "none";
      if(career == el.getAttribute("data-recruit") && job == el.getAttribute("data-job")) {
        el.style.display = "flex";
      }
      })


      })

  }

  modalClick();

  clickEvent();

  selectEvent();



  $(".modaal-01").modaal({
    content_source: '#modaal-01',
    animation_speed: '1000',
    background: '#333',
    background_scroll: true,
    overlay_opacity: '0.3',

});
  $(".modaal-02").modaal({
    content_source: '#modaal-02',
    animation_speed: '1000',
    background: '#333',
    background_scroll: false,
    overlay_opacity: '0.3',
});




  }


}

//noScroll
class Nav {
    constructor(el,opt){
      this.el = el;
			if($("." + this.el).length > 0){
				this.event();
			}
    }
    event(){
			window.addEventListener("resize", function(){
				const nav = document.querySelector(".menu");
				if(1200 < window.innerWidth){
					nav.classList.remove("is-active")
				};
			}
			)

  }
}
class RecruitClick {
	constructor(el,opt){
    this.el = el;
    if($(this.el).length){
      this.event();
    }
	}
	event(){


    const btn = document.querySelector(".recruitBtn");
    const block = document.querySelector(".block");
    const remove = document.querySelector(".newrecruitBtn")

    btn.addEventListener("click",() => {
      block.classList.remove("is-hidden");
    })

    remove.addEventListener("click",() => {
      block.classList.add("is-hidden")
    })

	}
}

//noScroll
class SelectEvent {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
			const Select = jQuery('.form-select');

			$.each(Select, function(i, val) {

				// コンソールに1つずつ出力

				jQuery(val).on('change', function(){
					if (jQuery(val).val() !== ""){
						jQuery(this).removeClass('form-select');
					} else {
						jQuery(this).addClass('form-select');
					}
				});

			});


  }
}

class ShopScript {
	constructor(el, opt) {
		this.el = el;
		if($(this.el).length){
			this.event();
		}
	}

	event(){
    let options = {
      threshold: [0.5]
    }
		if($('.s-bliss').length) {
			const observerEnter = new IntersectionObserver(entries => {
				entries.forEach(entry => {
					if(entry.intersectionRatio > 0.5) {
						$('.js-hdr-typ').removeClass('active');
					} else {
						$('.js-hdr-typ').addClass('active');
					}
				});
			}, options);

			let el = document.querySelectorAll('.s-mv-typ05, .mv-img');
			el.forEach(element => {
				observerEnter.observe(element);
			});
		}
		$(".js-hdr-drawer, .c-drawer01 .nav a").on('click', function(){
			$(".js-hdr-typ").toggleClass('is-active');
		})
		if($(".mySwiper").hasClass('s-member-type01__listWrap')) {
			if($('.mySwiper .swiper-slide').length <= 4) {
				$('html').addClass('member-few');
			}
			var swiper = new Swiper(".mySwiper", {
				// autoplay: {
				// 	disableOnInteraction: false,
				// 	delay: 4000,
				// },
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				speed: 1000,
				slidesPerView: 1.5,
				spaceBetween: 20,
				centeredSlides : true,
				loop: true,
				breakpoints: {
					960: {
						navigation: {
							nextEl: ".swiper-button-next",
							prevEl: ".swiper-button-prev",
						},
						loop: false,
						slidesPerView: 4,
						spaceBetween: 50,
						centeredSlides : false,
					}
				}
			});
		} else if($(".mySwiper").hasClass('s-member-type02__listWrap') && window.matchMedia( "(max-width: 980px)" ).matches) {
			var swiper = new Swiper(".mySwiper", {
				autoplay: {
					disableOnInteraction: false,
					delay: 4000,
				},
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				speed: 1000,
				slidesPerView: 1.4,
				spaceBetween: 20,
				centeredSlides : true,
				loop: true,
				breakpoints: {
					960: {
						slidesPerView: 4,
						spaceBetween: 50,
						centeredSlides : false,
					}
				}
			});
		}

		if($(".mySwiper").hasClass('s-member-type03__listWrap') && window.matchMedia( "(max-width: 980px)" ).matches) {
			var swiper = new Swiper(".mySwiper", {
				// autoplay: {
				// 	disableOnInteraction: false,
				// 	delay: 4000,
				// },
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				speed: 1500,
				slidesPerView: 1,
				spaceBetween: 20,
				centeredSlides : false,
				breakpoints: {
					960: {
						slidesPerView: 1,
						spaceBetween: 20,
						centeredSlides : true,
					}
				}
			});
		}

		var swiper_modal;

		$('.js-modal-trigger').on("click", function() {
			if($(`${$(this).attr('href')}`).length) {
				$(`${$(this).attr('href')}`).addClass('is-active');
				$("body").css({overflow: 'hidden'});

				if(`${$(this).attr('href')} .modal-swiper`.length) {
					swiper = new Swiper(`${$(this).attr('href')} .modal-swiper`, {
						slidesPerView: 1,
						speed: 500,
						centeredSlides : true,
						navigation: {
							nextEl: ".swiper-button-next",
							prevEl: ".swiper-button-prev",
						},
					});
					return false;
				}
			}
		})

		$('.js-overlay, .js-close').on('click', function() {
			$('.s-hair-type01__modal, .s-member-type01-modal, .s-member-modal, .s-staff-type01-modal').removeClass('is-active');
			$("body").css({overflow: 'inherit'});
			setTimeout(function() {
        swiper.destroy(false, true);
      }, 400)
		})

		$('.js-menu-tab li').on('click', function() {
			$('.js-menu-tab li').removeClass('is-active');
			$(this).addClass('is-active');
			$('.js-menu-inner').removeClass('is-active').css({'display': 'none'}).eq($(this).index()).fadeToggle();
		})

		if($(".s-hair-type02, .s-hair-type03").length) {
			new Swiper(".hair-swiper", {
				autoplay: {
					disableOnInteraction: false,
					delay: 4000,
				},
				slidesPerView: 1.3,
				spaceBetween: 10,
				loop: true,
				speed: 1000,
				centeredSlides : true,
				// navigation: {
				// 	nextEl: ".swiper-button-hair-next",
				// 	prevEl: ".swiper-button-hair-prev",
				// },
				breakpoints: {
					960: {
						centeredSlides : false,
						slidesPerView: 4,
						spaceBetween: 30,
						centeredSlides : false,
					}
				}
			});
		}

		if($(".c-hdr-typ04").length) {

			const w_ele = document.querySelector('.s-mv-typ04');

			const options = {
				threshold: 0
			};

			const observer = new IntersectionObserver(function(e) {
				if(!e[0].intersectionRatio > 0) {
					$(".c-hdr-typ04").addClass('is-scroll');
				} else {
					$(".c-hdr-typ04").removeClass('is-scroll');
				}
			}, options);

			observer.observe(w_ele);
		}

		if($(".c-hdr-typ05").length) {

			const w_ele = document.querySelector('.s-mv-typ05');
			const t_ele = document.querySelector('.s-contact-type05');

			const options = {
				threshold: 0
			};

			const observer = new IntersectionObserver(function(e) {
				if(!e[0].intersectionRatio > 0) {
					$(".c-hdr-typ05").addClass('is-scroll');
				} else {
					$(".c-hdr-typ05").removeClass('is-scroll');
				}
			}, options);

			const observer02 = new IntersectionObserver(function(e) {
				if(!e[0].intersectionRatio > 0) {
					$(".c-hdr-typ05").removeClass('is-footer');
				} else {
					$(".c-hdr-typ05").addClass('is-footer');
				}
			}, options);

			observer.observe(w_ele);
			observer02.observe(t_ele);
		}
	}
}



//noScroll
class SmoothScroll {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // メディアクエリがtrueかどうかをチェック
    var headerHeight = '';
    if($('.shop-header').length) {
      if (matchMedia('only screen and (max-width: 959px)').matches) {
        headerHeight = $('.shop-header')[0].clientHeight + $('.shop-header')[0].offsetTop + 40;     //fixedのヘッダーの高さを取得
      } else {
        headerHeight = $('.shop-header')[0].clientHeight + $('.shop-header')[0].offsetTop + 60;     //fixedのヘッダーの高さを取得
      }
    } else {
      headerHeight = $('.js-header').outerHeight();     //fixedのヘッダーの高さを取得
    }
    var urlHash = location.hash;    //URLハッシュを取得
    var animeSpeed = 500;   //スクロールのアニメーションスピード
    if(urlHash) {
      $('body,html').stop().scrollTop(0);
      setTimeout(function(){
        var target = $(urlHash.split('&')[0]);
        var position = target.offset().top - headerHeight;
        $('body,html').stop().animate({scrollTop:position}, animeSpeed);
      }, 100);
    }
    $('a[href^="#"]').on({
      'click': function(){
        var href = $(this).attr("href");
        console.log(href.indexOf('modal'));
        if(href.indexOf('modal') < 0) {
          var target = $(href);
          var position = target.offset().top - headerHeight;
          $('body,html').stop().animate({scrollTop:position}, animeSpeed);
        }
      }
    });
  }
}
 
class StaffScript {
	constructor(el, opt) {
		this.el = el;
		if($(this.el).length){
			this.event();
		}
	}

	event(){
    $('.js-modal-trigger').on("click", function() {
      if($(`${$(this).attr('href')}`).length) {
        $(`${$(this).attr('href')}`).addClass('is-active');
        $("body").css({overflow: 'hidden'});
      }
    })

    $('.js-overlay, .js-close').on('click', function() {
      $('.s-hair-type01__modal, .s-member-type01-modal, .s-member-modal, .s-staff-type01-modal').removeClass('is-active');
      $("body").css({overflow: 'inherit'});
    })
  }
}


(() => {

})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {

  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
  let smoothScroll = new SmoothScroll('js-header');
  let smoothScrollShop = new SmoothScroll('shop-header');
  let top = new Top(".top");
  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('.js-inview');
  // let clickEvent = new ClickEvent('js-click');
  let product = new Product('.p-product-lineup');
  let shop = new ShopScript('.p-shop');
  let staff = new StaffScript('.p-staff');
  let menuEvent = new Hamburger('.l-header');
  let selectEvent = new  SelectEvent('js-select');
  let nav = new Nav('js-nav');
  let accordion = new  Accordion('js-acc');
  let cielEvent = new Ciel('js-ciel');
  let modaal = new Modaal('js-modaal');
  let recruitClick = new RecruitClick('js-r-click');
  let hairModaal = new HairModaal('js-h-modaal');
  let footerMenu = new FooterMenu('js-f-menu');
  let productNew = new ProductNew('.p-product-new');
});

// スマホ・タブレットの向き判定
// $(window).on('orientationchange', ()=>{
//   if(isPortrait()){
//     console.log('isPortrait');
//   } else {
//     console.log('isLandscape');
//   }
// });